import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Route,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

// SERVICES
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanActivate {
  constructor(
    private featureToggleService :FeatureToggleService,
    private router :Router,
  ) {}

  canActivate(
    route :ActivatedRouteSnapshot,
    state :RouterStateSnapshot,
  ) :| Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const {
      data: { feature, callBackUrl = '/' },
    } = route;

    if (feature && this.featureToggleService.featureEnabled(feature)) {
      return true;
    }

    this.router.navigate([callBackUrl]);

    return false;
  }
}
